import React, { useState, useEffect } from 'react';
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";
import { app } from '../firebaseConfig'; 
import { Store, Clock, Loader2, Image as ImageIcon, Palette, Droplets, Copy, Sparkles, RefreshCw, Rocket, Facebook, Instagram, Link2, CheckCircle2 } from 'lucide-react'; // 🔥 Naye icons add kiye hain

const PEXELS_API_KEY = "31SVa8SDi76JV8kHCUKE0SBqDD7yjRlg8aXZNOyG1pUMM97zhUvRX0Uk"; 

const SocialAutopilot = ({ tenants }) => {
    const [selectedTenantId, setSelectedTenantId] = useState("");
    const [niche, setNiche] = useState("");
    const [bizName, setBizName] = useState("");
    const [topic, setTopic] = useState("");
    // 🔥 COMPETITOR SPY STATE
    const [competitorIntel, setCompetitorIntel] = useState(null);

    useEffect(() => {
        if (selectedTenantId) {
            const tenant = tenants.find(t => t.id === selectedTenantId);
            if (tenant && tenant.competitors && tenant.competitors.length > 0) {
                setCompetitorIntel(tenant.competitors[0]); // Fetch top competitor
            } else {
                setCompetitorIntel(null);
            }
        }
    }, [selectedTenantId, tenants]);
    // 🔥 PREMIUM DESIGN STATES 🔥
    const [designTheme, setDesignTheme] = useState("viral_highlighter"); 
    const [colorTheme, setColorTheme] = useState("light"); 
    const [rawBgImages, setRawBgImages] = useState([]); 
    
    const [scheduleTime, setScheduleTime] = useState("");
    const [suggestedTopics, setSuggestedTopics] = useState([]);
    
    const [isGenerating, setIsGenerating] = useState(false);
    const [isSuggesting, setIsSuggesting] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);
    
    const [logs, setLogs] = useState([]);
    const [caption, setCaption] = useState("");
    const [generatedImages, setGeneratedImages] = useState([]);
    const [generatedLayouts, setGeneratedLayouts] = useState([]);
    const [lastPayload, setLastPayload] = useState(null);
    const [slidesData, setSlidesData] = useState([]);

    useEffect(() => {
        if (selectedTenantId) {
            const tenant = tenants.find(t => t.id === selectedTenantId);
            if (tenant) {
                setBizName(tenant.name || "");
                setNiche(tenant.category || tenant.businessCandidate?.category || "Business");
            }
        }
    }, [selectedTenantId, tenants]);

    const logProcess = (msg, type = "loading") => {
        setLogs(prev => [...prev, { msg, type }]);
    };

    const handleQuickTime = (hoursAdded, isTomorrowObj = null) => {
        const now = new Date();
        if (hoursAdded) {
            now.setHours(now.getHours() + hoursAdded);
        } else if (isTomorrowObj) {
            now.setDate(now.getDate() + 1);
            now.setHours(isTomorrowObj.hours, 0, 0, 0);
        }
        const tzOffset = now.getTimezoneOffset() * 60000;
        const localISOTime = new Date(now.getTime() - tzOffset).toISOString().slice(0, 16);
        setScheduleTime(localISOTime);
    };

    const fetchBackgroundImages = async (searchQuery, count = 1) => {
        let colorModifier = colorTheme === 'dark' ? 'dark background' : 'bright professional';
        const aestheticQuery = `${searchQuery} ${colorModifier}`; 
        
        try {
            const pexRes = await fetch(`https://api.pexels.com/v1/search?query=${encodeURIComponent(aestheticQuery)}&per_page=${count}&orientation=portrait`, { 
                headers: { 'Authorization': PEXELS_API_KEY } 
            });
            if (pexRes.ok) {
                const pexData = await pexRes.json();
                return pexData.photos.map(p => p.src.large2x || p.src.large);
            }
        } catch(e) { console.warn("Image fetch failed", e); }
        return [];
    };

   // 🔥 ULTIMATE 4:5 PORTRAIT POST ENGINE 🔥
    const createPremiumCanvasGraphic = async (bgUrl, hookText, bodyText, biz, layoutPreset = null, themeColorPreset = 'light', slideIndex = 0, totalSlides = 1) => {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            canvas.width = 1080; canvas.height = 1350; 
            const ctx = canvas.getContext('2d');

            const wrapText = (context, text, x, y, maxWidth, lineHeight, isCentered = false) => {
                if(!text) return y; 
                const words = String(text).split(' ');
                let line = '';
                for(let n = 0; n < words.length; n++) {
                    let testLine = line + words[n] + ' ';
                    let metrics = context.measureText(testLine);
                    if (metrics.width > maxWidth && n > 0) {
                        if(isCentered) {
                            const currentLineWidth = context.measureText(line.trim()).width;
                            context.fillText(line.trim(), x + (maxWidth - currentLineWidth)/2, y);
                        } else {
                            context.fillText(line.trim(), x, y);
                        }
                        line = words[n] + ' ';
                        y += lineHeight;
                    } else { line = testLine; }
                }
                if(isCentered) {
                    const currentLineWidth = context.measureText(line.trim()).width;
                    context.fillText(line.trim(), x + (maxWidth - currentLineWidth)/2, y);
                } else {
                    context.fillText(line.trim(), x, y);
                }
                return y; 
            };

            const renderCanvas = (img) => {
                const availableLayouts = ['desi_influencer', 'twitter_thread', 'viral_highlighter', 'clean_infographic'];
                const selectedLayout = (layoutPreset && layoutPreset !== 'random') ? layoutPreset : availableLayouts[2]; // Default viral_highlighter

                ctx.fillStyle = "#F1F5F9";
                ctx.fillRect(0, 0, 1080, 1350);

                const drawCoverImage = (clipHeight = 1350, yOffset = 0) => {
                    if (img && img.width > 0) {
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(0, yOffset, 1080, clipHeight);
                        ctx.clip();
                        const scale = Math.max(1080 / img.width, clipHeight / img.height);
                        const x = 540 - (img.width*scale)/2;
                        const y = (clipHeight/2) - (img.height*scale)/2 + yOffset;
                        ctx.drawImage(img, x, y, img.width*scale, img.height*scale);
                        ctx.restore();
                    }
                };

                // =====================================
                // 🎨 1. DESI INFLUENCER
                // =====================================
                if (selectedLayout === 'desi_influencer') {
                    ctx.fillStyle = "#FFFFFF"; 
                    ctx.fillRect(0, 0, 1080, 1350);

                    ctx.textAlign = "left";
                    ctx.fillStyle = "#0F172A"; 
                    ctx.font = "900 85px 'Inter', sans-serif"; 
                    let hookEndY = wrapText(ctx, hookText || "Stop doing this mistake!", 80, 160, 920, 100, false);

                    let imgStartY = hookEndY + 60;
                    let imgHeight = 650;
                    
                    if (img && img.width > 0) {
                        ctx.save();
                        ctx.beginPath();
                        ctx.roundRect(80, imgStartY, 920, imgHeight, 40); 
                        ctx.clip();
                        const scale = Math.max(920 / img.width, imgHeight / img.height);
                        const x = 540 - (img.width * scale) / 2;
                        const y = imgStartY + (imgHeight/2) - (img.height * scale) / 2;
                        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
                        ctx.restore();
                    } else {
                        ctx.fillStyle = "#F1F5F9";
                        ctx.roundRect(80, imgStartY, 920, imgHeight, 40);
                        ctx.fill();
                    }

                    let boxStartY = imgStartY + imgHeight + 50;
                    ctx.fillStyle = "#0F172A"; 
                    ctx.roundRect(80, boxStartY, 920, 1350 - boxStartY - 60, 40);
                    ctx.fill();

                    ctx.fillStyle = "#FDE047"; 
                    ctx.font = "800 24px 'Montserrat', sans-serif";
                    ctx.letterSpacing = "2px";
                    ctx.fillText((biz || "BRAND").toUpperCase(), 130, boxStartY + 60);

                    ctx.fillStyle = "#FFFFFF";
                    ctx.font = "600 45px 'Inter', sans-serif";
                    wrapText(ctx, bodyText || "Here is the smart way to fix it today.", 130, boxStartY + 140, 820, 60, false);
                } 
                // =====================================
                // 🎨 2. TWITTER THREAD
                // =====================================
                else if (selectedLayout === 'twitter_thread') {
                    ctx.fillStyle = "#F8FAFC"; 
                    ctx.fillRect(0, 0, 1080, 1350);

                    ctx.fillStyle = "#FFFFFF";
                    ctx.shadowColor = "rgba(0, 0, 0, 0.08)";
                    ctx.shadowBlur = 40;
                    ctx.shadowOffsetY = 10;
                    ctx.roundRect(60, 200, 960, 950, 40);
                    ctx.fill();
                    ctx.shadowBlur = 0;

                    ctx.fillStyle = "#E2E8F0";
                    ctx.beginPath();
                    ctx.arc(160, 300, 50, 0, Math.PI * 2);
                    ctx.fill();
                    
                    ctx.textAlign = "left";
                    ctx.fillStyle = "#0F172A";
                    ctx.font = "800 35px 'Inter', sans-serif";
                    ctx.fillText((biz || "Brand Official"), 240, 290);
                    
                    ctx.fillStyle = "#64748B";
                    ctx.font = "500 25px 'Inter', sans-serif";
                    ctx.fillText("@" + (biz || "brand").replace(/\s/g, '').toLowerCase(), 240, 330);

                    ctx.fillStyle = "#0F172A";
                    ctx.font = "600 65px 'Inter', sans-serif";
                    let tweetEndY = wrapText(ctx, hookText || "This simple trick will change everything.", 120, 450, 840, 85, false);

                    if (img && img.width > 0) {
                        ctx.save();
                        ctx.beginPath();
                        ctx.roundRect(120, tweetEndY + 40, 840, 450, 30); 
                        ctx.clip();
                        const scale = Math.max(840 / img.width, 450 / img.height);
                        const x = 540 - (img.width * scale) / 2;
                        const y = tweetEndY + 40 + (450/2) - (img.height * scale) / 2;
                        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
                        ctx.restore();
                    }

                    ctx.fillStyle = "#3B82F6"; 
                    ctx.font = "600 35px 'Inter', sans-serif";
                    wrapText(ctx, bodyText || "Read the thread below 🧵", 120, 1080, 840, 50, false);
                }
                // =====================================
                // 🎨 3. VIRAL HIGHLIGHTER
                // =====================================
                else if (selectedLayout === 'viral_highlighter') {
                    ctx.fillStyle = "#F8FAFC"; 
                    ctx.fillRect(0, 0, 1080, 1350);

                    ctx.fillStyle = "#FFFFFF";
                    ctx.shadowColor = "rgba(0, 0, 0, 0.08)";
                    ctx.shadowBlur = 40;
                    ctx.shadowOffsetY = 20;
                    if(ctx.roundRect) {
                        ctx.beginPath();
                        ctx.roundRect(60, 60, 960, 1230, 40);
                        ctx.fill();
                    } else {
                        ctx.fillRect(60, 60, 960, 1230);
                    }
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetY = 0;

                    ctx.textAlign = "left";
                    ctx.fillStyle = "#64748B";
                    ctx.font = "800 22px 'Montserrat', sans-serif";
                    ctx.letterSpacing = "2px";
                    ctx.fillText((biz || "BRAND").toUpperCase(), 120, 140);

                    ctx.textAlign = "left";
                    ctx.font = "900 80px 'Inter', sans-serif"; 
                    
                    const maxWidth = 840; 
                    const lineHeight = 95;
                    let currentY = 250;
                    
                    const hookWords = (hookText || "Premium Value Content").split(" ");
                    let lines = [];
                    let currentLine = "";

                    for (let i = 0; i < hookWords.length; i++) {
                        let testLine = currentLine + hookWords[i] + " ";
                        let metrics = ctx.measureText(testLine);
                        if (metrics.width > maxWidth && i > 0) {
                            lines.push(currentLine.trim());
                            currentLine = hookWords[i] + " ";
                        } else {
                            currentLine = testLine;
                        }
                    }
                    lines.push(currentLine.trim());

                    for (let i = 0; i < lines.length; i++) {
                        let line = lines[i];
                        if (i === lines.length - 1) { 
                            let lineWidth = ctx.measureText(line).width;
                            ctx.fillStyle = "#FDE047"; 
                            ctx.fillRect(120 - 15, currentY - 75, lineWidth + 30, 90);
                        }
                        ctx.fillStyle = "#0F172A"; 
                        ctx.fillText(line, 120, currentY);
                        currentY += lineHeight;
                    }

                    let bodyStartY = currentY + 30;
                    ctx.fillStyle = "#475569";
                    ctx.font = "500 38px 'Inter', sans-serif";
                    let bodyEndY = wrapText(ctx, bodyText || "Mastering digital marketing opens doors.", 120, bodyStartY, 840, 55, false);

                    if (img && img.width > 0) {
                        ctx.save();
                        const imgWidth = 840;
                        let imgHeight = 1230 - bodyEndY - 50; 
                        if (imgHeight > 650) imgHeight = 650; 
                        
                        const imgX = 120;
                        const imgY = 1230 - imgHeight - 20; 
                        const radius = 32;

                        if(ctx.roundRect) {
                            ctx.beginPath();
                            ctx.roundRect(imgX, imgY, imgWidth, imgHeight, radius);
                            ctx.clip(); 
                        } else {
                            ctx.beginPath();
                            ctx.rect(imgX, imgY, imgWidth, imgHeight);
                            ctx.clip();
                        }

                        const scale = Math.max(imgWidth / img.width, imgHeight / img.height);
                        const x = imgX - ((img.width * scale) - imgWidth) / 2;
                        const y = imgY - ((img.height * scale) - imgHeight) / 2;
                        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
                        ctx.restore();
                    }
                } 
                // =====================================
                // 🎨 4. CLEAN INFOGRAPHIC
                // =====================================
                else if (selectedLayout === 'clean_infographic') {
                    drawCoverImage(1350);
                    
                    ctx.fillStyle = "rgba(255, 255, 255, 0.95)";
                    ctx.fillRect(60, 60, 960, 550); 
                    
                    ctx.strokeStyle = "#0F172A";
                    ctx.lineWidth = 8;
                    ctx.strokeRect(60, 60, 960, 550);

                    ctx.textAlign = "left";
                    ctx.fillStyle = "#2563EB";
                    ctx.font = "800 25px 'Montserrat', sans-serif";
                    ctx.letterSpacing = "2px";
                    ctx.fillText("— " + (biz || "BRAND").toUpperCase(), 110, 140);

                    ctx.fillStyle = "#0F172A";
                    ctx.font = "900 85px 'Inter', sans-serif"; 
                    wrapText(ctx, hookText || "Premium Value Hook", 110, 260, 860, 100, false);

                    ctx.fillStyle = "#475569"; 
                    ctx.font = "600 40px 'Inter', sans-serif";
                    wrapText(ctx, bodyText || "Check out the detailed insights.", 110, 480, 860, 55, false);
                }

                // 🔥 GLOBAL CAROUSEL UI ENGINE (Applies to all layouts) 🔥
                if (totalSlides > 1) {
                    ctx.save();
                    if (slideIndex < totalSlides - 1) {
                        // SWIPE & DOTS (For slides 1 to N-1)
                        ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
                        ctx.roundRect(830, 1260, 160, 50, 25);
                        ctx.fill();

                        ctx.fillStyle = "#FFFFFF";
                        ctx.font = "700 22px 'Inter', sans-serif";
                        ctx.textAlign = "center";
                        ctx.fillText("Swipe 👉", 910, 1293);

                        let dotsWidth = (totalSlides * 15) + ((totalSlides - 1) * 10);
                        let startDotX = 540 - (dotsWidth / 2);
                        for (let d = 0; d < totalSlides; d++) {
                            ctx.beginPath();
                            ctx.arc(startDotX + (d * 25), 1285, 6, 0, Math.PI * 2);
                            ctx.fillStyle = d === slideIndex ? "#0F172A" : "rgba(15, 23, 42, 0.2)";
                            ctx.fill();
                        }
                    } else {
                        // HUGE CTA BUTTON (For the very last slide)
                        ctx.shadowColor = "rgba(0, 0, 0, 0.3)";
                        ctx.shadowBlur = 30;
                        ctx.shadowOffsetY = 15;
                        ctx.fillStyle = "#FDE047"; 
                        
                        const btnWidth = 450;
                        const btnHeight = 85;
                        const btnX = 540 - (btnWidth / 2);
                        const btnY = 1220;

                        if(ctx.roundRect) {
                            ctx.beginPath();
                            ctx.roundRect(btnX, btnY, btnWidth, btnHeight, 42);
                            ctx.fill();
                        } else {
                            ctx.fillRect(btnX, btnY, btnWidth, btnHeight);
                        }
                        ctx.shadowBlur = 0;
                        ctx.shadowOffsetY = 0;

                        ctx.fillStyle = "#0F172A";
                        ctx.font = "900 28px 'Inter', sans-serif";
                        ctx.textAlign = "center";
                        ctx.fillText("👉 LINK IN BIO", 540, btnY + 52);
                    }
                    ctx.restore();
                }

                resolve({ dataUrl: canvas.toDataURL('image/jpeg', 1.0), layoutUsed: selectedLayout }); 
            };

            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => renderCanvas(img);
            img.onerror = () => renderCanvas(null); 
            img.src = bgUrl || "";
        });
    };

    const uploadToCloud = async (base64Data) => {
        try {
            const storage = getStorage(app);
            const fileName = `social_posts/post_${Date.now()}_${Math.random().toString(36).substring(7)}.jpg`;
            const storageRef = ref(storage, fileName);
            await uploadString(storageRef, base64Data, 'data_url');
            return await getDownloadURL(storageRef);
        } catch (error) {
            console.error("Firebase Upload Failed:", error);
            throw new Error("Cloud upload failed.");
        }
    };

    const suggestHooks = async () => {
        if(!niche) return alert("Select a business or enter a niche first.");
        setIsSuggesting(true);
        try {
            const prompt = `Act as an Elite Marketing Strategist. Suggest 3 viral 'Problem vs Solution' style topics for a "${niche}" brand. Return ONLY raw JSON array of strings: ["Topic 1", "Topic 2", "Topic 3"]`;
            const res = await fetch(`https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/generateSocialContent`, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({ prompt: prompt }) });
            const result = await res.json();
            if (!res.ok || !result.success || !result.data?.candidates) throw new Error("Backend failed");
            const aiText = result.data.candidates[0].content.parts[0].text;
            const topics = JSON.parse(aiText.replace(/```json/gi, '').replace(/```/gi, '').trim());
            setSuggestedTopics(topics);
        } catch(e) { console.error(e); alert("Failed to get suggestions. Check backend logs."); } finally { setIsSuggesting(false); }
    };

   const generatePost = async (type) => {
        if(!selectedTenantId) return alert("Please select a Business (Tenant) first!");
        if(!topic) return alert("Please enter or select a topic!");
        
        setIsGenerating(true);
        setLogs([]);
        setCaption("");
        setGeneratedImages([]);
        setGeneratedLayouts([]);
        setRawBgImages([]); 
        setSlidesData([]);

        try {
            logProcess("Connecting to Secure AI Backend for Strategy...");
            
            const slideCount = type === 'carousel' ? 4 : 1;
            const storyLogic = type === 'carousel' 
                ? `Create a cohesive 4-slide storytelling sequence. Slide 1: The Hook/Problem. Slide 2: The Myth. Slide 3: The Solution. Slide 4: The CTA.` 
                : `Create a single, high-impact post.`;

            const prompt = `Act as a top Instagram Growth Hacker for the "${niche}" industry.
            Business Name: "${bizName}" | Topic: "${topic}" | Post Type: ${type}

          STRICT COPYWRITING RULES FOR HIGH CONVERSION:
            1. ${storyLogic}
            2. The 'hook': Hit a direct relatable pain point (4-6 words). 
            🔥 CRITICAL GRAMMAR RULE: The hook MUST be a complete sentence and MUST end with a proper NOUN (like 'Growth', 'Sales', 'Results', 'Career', 'Traffic'). 
            ❌ BAD HOOKS (NEVER USE): "Tired of low", "Tired of mediocre", "Stop doing this".
            ✅ GOOD HOOKS (ALWAYS USE): "Tired of mediocre results?", "Struggling with low sales?", "Tired of a mediocre career?".
            3. The 'body': Exactly 1 simple punchy sentence offering the solution or next step.

            Return ONLY valid JSON matching this exact structure with EXACTLY ${slideCount} slide(s):
            {
              "slides": [ 
                  { "hook": "Simple relatable hook?", "body": "Simple solution body.", "kw": "emotion portrait keyword" }
              ],
              "caption": "Your compelling viral caption here... Use \\n for new lines. Keep it punchy and actionable."
            }`;

            const res = await fetch(`https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/generateSocialContent`, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({ prompt: prompt }) });
            const result = await res.json();
            if (!res.ok || !result.success || !result.data?.candidates) throw new Error("Backend or AI rejected the request.");
            
            let rawJson = result.data.candidates[0].content.parts[0].text.replace(/^```json\s*/i, '').replace(/\s*```$/i, '').trim();
            rawJson = rawJson.replace(/[\u0000-\u001F]+/g, ""); 
            const payload = JSON.parse(rawJson);
            
            logProcess("AI Strategy Ready!", "success");
            setCaption(payload.caption.replace(/\\n/g, '\n'));
            setSlidesData(payload.slides);

            const urls = [];
            const layouts = [];
            const rawUrls = [];
            let masterLayout = designTheme === 'random' ? null : designTheme;

            for (let i = 0; i < payload.slides.length; i++) {
                const slide = payload.slides[i];
                logProcess(`Generating Slide ${i+1}/${payload.slides.length}...`);

                const bgImages = await fetchBackgroundImages(slide.kw, 1);
                const bgImageUrl = bgImages[0] || "";
                rawUrls.push(bgImageUrl);

                // Pass slide index & total slides for dynamic CTA
                const imgResult = await createPremiumCanvasGraphic(bgImageUrl, slide.hook, slide.body, bizName, masterLayout, colorTheme, i, payload.slides.length);
                if(!masterLayout && type === 'carousel') masterLayout = imgResult.layoutUsed;
                
                layouts.push(imgResult.layoutUsed);
                const cloudUrl = await uploadToCloud(imgResult.dataUrl);
                urls.push(cloudUrl);
            }

            logProcess("All Graphics Rendered and Uploaded!", "success");
            setGeneratedImages(urls);
            setGeneratedLayouts(layouts);
            setRawBgImages(rawUrls);

            setLastPayload({ postType: "image", type: type, topic, bizName, caption: payload.caption, imageUrl: urls[0], images_array: urls, tenantId: selectedTenantId });

        } catch(e) { console.error("Error:", e); logProcess("Process Failed. Please check console.", "error"); } finally { setIsGenerating(false); }
    };

    const handleImageReplace = async (e, index) => {
        const file = e.target.files[0];
        if(!file) return;
        
        const slide = slidesData[index];
        const layoutUsed = generatedLayouts[index]; 
        
        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const base64 = event.target.result;
                const newRaws = [...rawBgImages];
                newRaws[index] = base64;
                setRawBgImages(newRaws);

                const imgResult = await createPremiumCanvasGraphic(base64, slide.hook, slide.body, bizName, layoutUsed, colorTheme, index, slidesData.length);
                const newCloudUrl = await uploadToCloud(imgResult.dataUrl);

                const newImgs = [...generatedImages];
                newImgs[index] = newCloudUrl;
                setGeneratedImages(newImgs);

                if(lastPayload) {
                    const newPayload = {...lastPayload};
                    newPayload.images_array[index] = newCloudUrl;
                    if(index === 0) newPayload.imageUrl = newCloudUrl;
                    setLastPayload(newPayload);
                }
                alert("✅ Custom Image Applied!");
            } catch(err) { console.error(err); alert("❌ Failed to replace image"); }
        };
        reader.readAsDataURL(file);
    };

    const handleRotateDesign = async (index) => {
        const slide = slidesData[index];
        const rawBg = rawBgImages[index];
        if (!slide || !rawBg) return alert("Original data missing!");

        try {
            const availableLayouts = ['desi_influencer', 'twitter_thread', 'viral_highlighter', 'clean_infographic'];
            const currentLayout = generatedLayouts[index];
            const newLayouts = availableLayouts.filter(l => l !== currentLayout);
            const randomNewLayout = newLayouts[Math.floor(Math.random() * newLayouts.length)];

            const imgResult = await createPremiumCanvasGraphic(rawBg, slide.hook, slide.body, bizName, randomNewLayout, colorTheme, index, slidesData.length);
            const newCloudUrl = await uploadToCloud(imgResult.dataUrl);

            const newImgs = [...generatedImages];
            newImgs[index] = newCloudUrl;
            setGeneratedImages(newImgs);

            const newLayoutsState = [...generatedLayouts];
            newLayoutsState[index] = imgResult.layoutUsed;
            setGeneratedLayouts(newLayoutsState);

            if(lastPayload) {
                const newPayload = {...lastPayload};
                newPayload.images_array[index] = newCloudUrl;
                if(index === 0) newPayload.imageUrl = newCloudUrl;
                setLastPayload(newPayload);
            }
        } catch(e) { console.error(e); alert("Failed to rotate design."); }
    };

    // 🔥 META DISCONNECT HANDLER 🔥
    const [isDisconnecting, setIsDisconnecting] = useState(false);

    const handleDisconnectMeta = async () => {
        if (!selectedTenantId) return;
        const confirmDisconnect = window.confirm("⚠️ Are you sure?\n\nYeh client ka Facebook & Instagram connection remove kar dega. Post publishing band ho jayega.");
        if (!confirmDisconnect) return;

        setIsDisconnecting(true);
        try {
            const res = await fetch(`https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/disconnectMeta`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ clientId: selectedTenantId })
            });
            const result = await res.json();
            if (result.success) {
                alert("✅ Meta accounts successfully disconnect ho gaye!");
                window.location.reload(); // Refresh to reflect updated token state
            } else {
                alert("❌ Disconnect failed: " + (result.error || "Unknown error"));
            }
        } catch (e) {
            alert("❌ Network Error: Could not reach server.");
        } finally {
            setIsDisconnecting(false);
        }
    };

   // 🔥 PUBLISH ENGINE WITH META SYNC (Fixed Token Logic) 🔥
    const handlePublish = async () => {
        if(!lastPayload) return;
        
        const tenant = tenants.find(t => t.id === selectedTenantId);
        if(!tenant) return alert("❌ Error: Client not found in the system.");
        
        // 🔄 SYNC FIX: WhatsApp bot ki tarah fbPageToken aur metaToken dono check karega
        const activeToken = tenant.fbPageToken || tenant.metaToken;
        
        if(!tenant.fbPageId || !activeToken) {
            return alert("⚠️ Action Required: Is client ka FB Page ID ya Token set nahi hai.\n\nKripya pehle Dashboard se 'Connect Facebook' par click karke Meta accounts link karein.");
        }

        setIsPublishing(true);
        
        const finalPayload = { 
            imageUrl: lastPayload.imageUrl, 
            imagesArray: lastPayload.images_array, // Sending Array for Carousel
            caption: caption, 
            metaToken: activeToken, // Sync fix
            fbPageId: tenant.fbPageId 
        };
        
        try {
            const res = await fetch('https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/publishToMeta', { 
                method: 'POST', 
                headers: {'Content-Type': 'application/json'}, 
                body: JSON.stringify(finalPayload) 
            });
            
            const result = await res.json();
            
            if(result.success) {
                alert(`✅ Post Published!\nFB: ${result.report.facebook}\nIG: ${result.report.instagram}\n${result.report.igError ? "Error: " + result.report.igError : ""}`);
            } else {
                alert(`❌ Failed to Publish:\n${result.error}`);
            }
        } catch(e) { 
            alert("❌ Network Error: Could not reach the publishing engine!"); 
        } finally { 
            setIsPublishing(false); 
        }
    };
    
    return (
        <div className="animate-fade-in pb-10 px-4 md:px-8 max-w-6xl mx-auto mt-6">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                    <span className="bg-gradient-to-r from-blue-700 to-indigo-700 text-white p-3 rounded-xl shadow-lg">
                        <ImageIcon size={24} />
                    </span>
                    <div>
                        <h2 className="text-3xl font-black text-slate-800 tracking-tight">Social Autopilot Pro</h2>
                        <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">Agency Publishing Engine</p>
                    </div>
                </div>
            </div>
            
            <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-sm border border-slate-200 mb-8">
                
                <div className="mb-6 bg-slate-50 p-4 rounded-xl border border-slate-200">
                    <label className="block text-sm font-black text-slate-700 mb-2 flex items-center gap-2"><Store size={16} className="text-indigo-600"/> Select Client Business</label>
                    <select 
                        value={selectedTenantId} 
                        onChange={(e) => setSelectedTenantId(e.target.value)} 
                        className="w-full p-3 rounded-xl border border-slate-300 outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700"
                    >
                        <option value="">-- Choose a Client to manage --</option>
                        {tenants.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>

                    {/* 🔥 COMPETITOR SPY INTELLIGENCE CARD */}
             
                </div>
                   {competitorIntel && (
                    <div className="mb-6 bg-gradient-to-r from-rose-950 via-slate-900 to-rose-950 p-5 rounded-2xl border border-rose-500/30 text-white shadow-xl animate-in fade-in">
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                            <div>
                                <span className="text-[10px] font-black bg-rose-500/20 text-rose-400 border border-rose-500/30 px-2.5 py-1 rounded-md uppercase tracking-wider">
                                    🕵️‍♂️ Market Spy Intel
                                </span>
                                <h3 className="text-lg font-black mt-2">Top Competitor: {competitorIntel.name}</h3>
                                <p className="text-xs text-slate-300 mt-1">
                                    Rating: ⭐ {competitorIntel.rating || 'N/A'} ({competitorIntel.reviews || 0} reviews)
                                </p>
                            </div>
                            <button 
                                onClick={() => {
                                    setTopic(`Counter-attack strategy against ${competitorIntel.name}. Highlight our superior quality and fast response.`);
                                    alert("✅ Competitor weakness loaded into Topic! Now click 'Generate Post'.");
                                }}
                                className="bg-rose-600 hover:bg-rose-700 text-white text-xs font-black px-4 py-3 rounded-xl shadow-lg transition-all active:scale-95"
                            >
                                ⚔️ Generate Counter-Post
                            </button>
                        </div>
                    </div>
                )}

                {/* 🔥 NEW META INTEGRATION SECTION (FOR APP REVIEW) 🔥 */}
                {selectedTenantId && (
                    <div className="mb-6 p-5 bg-white rounded-2xl border border-slate-200 shadow-sm animate-fade-in">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <div className="flex items-center gap-4">
                                <div className="flex items-center gap-1.5 bg-gradient-to-br from-blue-500 to-pink-500 p-3 rounded-2xl shadow-lg shadow-pink-200">
                                    <Facebook size={20} className="text-white" />
                                    <Instagram size={20} className="text-white" />
                                </div>
                                <div>
                                    <h3 className="text-base font-black text-slate-800">Meta Social Integrations</h3>
                                    <p className="text-xs text-slate-500 mt-0.5 font-medium">Connect accounts for direct scheduling & publishing.</p>
                                </div>
                            </div>
                            
                            {tenants.find(t => t.id === selectedTenantId)?.fbPageToken || tenants.find(t => t.id === selectedTenantId)?.metaToken ? (
                                <div className="flex items-center gap-3 flex-wrap">
                                    <div className="bg-emerald-500 text-white px-5 py-3 rounded-xl flex items-center gap-2 font-black shadow-md shadow-emerald-200">
                                        <CheckCircle2 size={18} /> Accounts Connected
                                    </div>
                                    <button
                                        onClick={handleDisconnectMeta}
                                        disabled={isDisconnecting}
                                        className="bg-white hover:bg-red-600 text-red-500 hover:text-white border-2 border-red-200 hover:border-red-600 font-black py-3 px-5 rounded-xl transition-all duration-200 flex items-center gap-2 active:scale-95 disabled:opacity-50 shadow-sm"
                                    >
                                        {isDisconnecting ? <Loader2 size={16} className="animate-spin" /> : <Link2 size={16} />}
                                        {isDisconnecting ? 'Disconnecting...' : 'Disconnect'}
                                    </button>
                                </div>
                            ) : (
                                <button 
onClick={() => window.location.href = `https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/metaLogin?clientId=${selectedTenantId}`}
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-black py-3 px-6 rounded-xl shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 transition-all flex items-center gap-2 active:scale-95"
                                >
                                    <Link2 size={18} /> Connect Facebook & Instagram
                                </button>
                            )}
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2">Category (Niche)</label>
                        <input type="text" value={niche} onChange={(e)=>setNiche(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-300 outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="e.g. Cafe" />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2">Brand Name</label>
                        <input type="text" value={bizName} onChange={(e)=>setBizName(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-300 outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="e.g. Pivot Edu Unit" />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-1"><Palette size={16}/> Layout Style</label>
                        <select 
                            value={designTheme} 
                            onChange={(e) => setDesignTheme(e.target.value)} 
                            className="w-full p-3.5 rounded-xl border border-slate-300 outline-none focus:ring-2 focus:ring-blue-500 font-semibold text-slate-700 bg-white"
                        >
                            <option value="viral_highlighter">💡 Viral Highlighter (Best)</option>
                            <option value="desi_influencer">🔥 Desi Influencer</option>
                            <option value="twitter_thread">🧵 Twitter Thread</option>
                            <option value="clean_infographic">📊 Clean Box</option>
                            <option value="random">🎲 Auto-Random</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-1"><Droplets size={16}/> Color Theme</label>
                        <select 
                            value={colorTheme} 
                            onChange={(e) => setColorTheme(e.target.value)} 
                            className="w-full p-3.5 rounded-xl border border-slate-300 outline-none focus:ring-2 focus:ring-blue-500 font-semibold text-slate-700 bg-white"
                        >
                            <option value="light">☀️ Light & Clean (Best)</option>
                            <option value="dark">🌙 Dark & Bold</option>
                        </select>
                    </div>
                </div>

                <div className="mb-8">
                    <div className="flex justify-between items-center mb-2">
                        <label className="text-sm font-bold text-slate-700">Campaign Topic</label>
                        <button onClick={suggestHooks} disabled={isSuggesting} className="text-xs font-black text-blue-600 bg-blue-50 px-3 py-1.5 rounded-full border border-blue-100 hover:bg-blue-600 hover:text-white transition-all shadow-sm disabled:opacity-50">
                            {isSuggesting ? '⏳ Scanning...' : '✨ Suggest Viral Hooks'}
                        </button>
                    </div>
                    <input type="text" value={topic} onChange={(e)=>setTopic(e.target.value)} className="w-full p-4 rounded-xl border-2 border-slate-200 focus:border-blue-500 text-lg font-medium outline-none shadow-inner" placeholder="Enter topic..." />
                    
                    {suggestedTopics.length > 0 && (
                        <div className="mt-3 flex flex-wrap gap-2 animate-in fade-in">
                            {suggestedTopics.map((t, idx) => (
                                <button key={idx} onClick={() => setTopic(t)} className="bg-white text-blue-600 text-xs font-bold px-4 py-2 rounded-full border border-blue-100 hover:bg-blue-600 hover:text-white shadow-sm transition-all">{t}</button>
                            ))}
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="p-6 bg-slate-900 rounded-3xl border border-slate-700 shadow-xl relative overflow-hidden group">
                        <div className="absolute -top-10 -right-10 w-32 h-32 bg-blue-500 rounded-full blur-[60px] opacity-20 group-hover:opacity-40 transition-opacity"></div>
                        <label className="block text-sm font-black text-blue-400 mb-4 flex items-center gap-2 relative z-10"><Clock size={16}/> Smart Auto-Scheduler</label>
                        <div className="grid grid-cols-2 gap-2 mb-4 relative z-10">
                            <button onClick={() => handleQuickTime(2)} className="bg-slate-800 hover:bg-blue-600 text-slate-300 hover:text-white text-[11px] font-bold py-2.5 px-2 rounded-lg transition-all border border-slate-700">🕒 In 2 Hours</button>
                            <button onClick={() => handleQuickTime(null, {hours:9})} className="bg-slate-800 hover:bg-blue-600 text-slate-300 hover:text-white text-[11px] font-bold py-2.5 px-2 rounded-lg transition-all border border-slate-700">🌅 Tomorrow 9 AM</button>
                            <button onClick={() => handleQuickTime(null, {hours:18})} className="bg-slate-800 hover:bg-blue-600 text-slate-300 hover:text-white text-[11px] font-bold py-2.5 px-2 rounded-lg transition-all border border-slate-700">🌆 Tomorrow 6 PM</button>
                            <button onClick={() => setScheduleTime("")} className="bg-blue-900 hover:bg-green-600 text-blue-200 hover:text-white text-[11px] font-bold py-2.5 px-2 rounded-lg transition-all border border-blue-800">⚡ Post NOW</button>
                        </div>
                        <div className="relative z-10">
                            <input type="datetime-local" value={scheduleTime} onChange={(e) => setScheduleTime(e.target.value)} className="w-full p-3 rounded-xl border border-slate-700 bg-slate-800 text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all text-xs font-mono cursor-pointer" />
                        </div>
                    </div>

                    <div className="p-6 bg-purple-50 rounded-3xl border border-purple-100 shadow-sm flex flex-col justify-between">
                        <div>
                            <label className="block text-sm font-black text-purple-800 mb-1">🎬 Viral Reel Ideas</label>
                            <p className="text-[11px] text-purple-600 mb-4 leading-relaxed">AI analyzes trending audio & hooks for your specific niche.</p>
                        </div>
                        <button className="w-full bg-purple-600 text-white font-bold py-3 rounded-xl hover:bg-purple-700 transition-all shadow-lg shadow-purple-200 active:scale-95">🚀 Coming Soon</button>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <button onClick={() => generatePost('single')} disabled={isGenerating} className="bg-slate-800 text-white font-black py-4 rounded-2xl shadow-xl hover:bg-slate-700 transition-all text-lg flex items-center justify-center gap-3 disabled:opacity-50">
                        {isGenerating ? <Loader2 className="animate-spin" /> : '🖼️ Generate Single Post'}
                    </button>
                    <button onClick={() => generatePost('carousel')} disabled={isGenerating} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-black py-4 rounded-2xl shadow-xl hover:shadow-blue-500/40 transition-all text-lg flex items-center justify-center gap-3 disabled:opacity-50">
                        {isGenerating ? <Loader2 className="animate-spin" /> : '📚 Premium Carousel'}
                    </button>
                </div>

                {logs.length > 0 && (
                    <div className="mt-8 p-5 bg-slate-900 rounded-2xl border border-slate-700 shadow-2xl overflow-hidden animate-in fade-in zoom-in">
                        <div className="flex items-center gap-2 mb-3 border-b border-slate-800 pb-2">
                            <div className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse"></div>
                            <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Agency System Terminal</h4>
                        </div>
                        <div className="flex flex-col gap-2 font-mono scroll-smooth max-h-40 overflow-y-auto custom-scrollbar">
                            {logs.map((log, i) => (
                                <div key={i} className={`flex items-center gap-2 text-xs animate-fade-in ${log.type === 'success' ? 'text-green-400' : log.type === 'error' ? 'text-red-400' : 'text-blue-300'}`}>
                                    {log.type === 'loading' && <span className="animate-spin text-sm">⚙️</span>}
                                    {log.type === 'success' && <span className="text-sm">✅</span>}
                                    {log.type === 'error' && <span className="text-sm">❌</span>}
                                    <span className={log.type !== 'loading' ? 'font-bold' : ''}>{log.msg}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* 🔥 PREMIUM CONTENT GENERATION SECTION 🔥 */}
            {generatedImages.length > 0 && (
                <div className="mt-12 border-t border-slate-200/60 pt-12 animate-in slide-in-from-bottom-8">
                    
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6">
                        <div>
                            <h2 className="text-3xl md:text-4xl font-black bg-clip-text text-transparent bg-gradient-to-r from-slate-900 via-indigo-800 to-slate-900 tracking-tight flex items-center gap-3">
                                ✨ Content Masterpiece
                            </h2>
                            <p className="text-sm text-slate-500 font-medium mt-2">Your AI-generated, high-converting creatives are ready for review.</p>
                        </div>
                        
                        <button onClick={handlePublish} disabled={isPublishing} className="group relative px-8 py-4 font-black text-white rounded-2xl overflow-hidden shadow-2xl shadow-indigo-500/30 transition-all active:scale-95 disabled:opacity-50 disabled:shadow-none">
                            <div className={`absolute inset-0 transition-transform duration-500 group-hover:scale-105 ${scheduleTime ? 'bg-gradient-to-r from-blue-600 to-cyan-500' : 'bg-gradient-to-r from-emerald-500 to-teal-400'}`}></div>
                            <div className="relative flex items-center justify-center gap-2 text-lg tracking-wide">
                                {isPublishing ? <Loader2 className="animate-spin" /> : (scheduleTime ? <><Clock size={20}/> Schedule Post</> : <><Rocket size={20} className="group-hover:-translate-y-1 transition-transform duration-300"/> Publish Now</>)}
                            </div>
                        </button>
                    </div>
                    
                    <div className="mb-12 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
                        {generatedImages.map((url, idx) => (
                            <div key={idx} className="relative group flex flex-col items-center bg-white p-3.5 rounded-[32px] shadow-xl shadow-slate-200/50 border border-slate-100 hover:shadow-2xl hover:shadow-indigo-500/10 transition-all duration-500 w-full max-w-[360px]">
                                
                                <div className="overflow-hidden rounded-[24px] relative w-full aspect-[4/5] bg-slate-100 shadow-inner">
                                    <img src={url} alt="Generated" className="w-full h-full object-cover transform transition-transform duration-700" />
                                </div>
                                
                                <div className="flex gap-3 mt-4 mb-1 w-full px-2">
                                    <label className="flex-1 cursor-pointer bg-slate-50 hover:bg-indigo-50 text-slate-600 hover:text-indigo-700 text-[11px] font-black px-4 py-3 rounded-xl border border-slate-200 hover:border-indigo-200 shadow-sm flex justify-center items-center gap-2 transition-all active:scale-95 group/btn">
                                        <ImageIcon size={14} className="group-hover/btn:scale-110 transition-transform" /> 
                                        <span>Change</span>
                                        <input type="file" className="hidden" accept="image/*" onChange={(e) => handleImageReplace(e, idx)} />
                                    </label>

                                    <button onClick={() => handleRotateDesign(idx)} className="flex-1 cursor-pointer bg-slate-50 hover:bg-rose-50 text-slate-600 hover:text-rose-600 text-[11px] font-black px-4 py-3 rounded-xl border border-slate-200 hover:border-rose-200 shadow-sm flex justify-center items-center gap-2 transition-all active:scale-95 group/btn">
                                        <RefreshCw size={14} className="group-hover/btn:rotate-180 transition-transform duration-500" /> 
                                        <span>Rotate</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className="w-full bg-[#0f172a] p-1.5 rounded-[32px] shadow-2xl relative overflow-hidden group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-500"></div>
                        
                        <div className="relative bg-[#0f172a] rounded-[28px] h-full w-full flex flex-col">
                            <div className="flex justify-between items-center px-6 py-4 border-b border-slate-800/80 bg-slate-900/50 rounded-t-[28px]">
                                <div className="flex items-center gap-3">
                                    <div className="flex gap-1.5">
                                        <div className="w-3 h-3 rounded-full bg-rose-500"></div>
                                        <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                                        <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
                                    </div>
                                    <h4 className="text-indigo-400 font-bold text-xs tracking-wider uppercase flex items-center gap-2 ml-2">
                                        <Sparkles size={14}/> Agency Optimized Copy
                                    </h4>
                                </div>
                                <button 
                                    onClick={() => { navigator.clipboard.writeText(caption); alert("Caption Copied! ✅"); }} 
                                    className="text-slate-400 hover:text-white bg-slate-800 hover:bg-slate-700 p-2 rounded-lg transition-colors flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest"
                                >
                                    <Copy size={12}/> Copy
                                </button>
                            </div>
                            
                            <textarea 
                                value={caption} 
                                onChange={(e)=>setCaption(e.target.value)} 
                                className="w-full min-h-[220px] bg-transparent text-slate-300 text-[15px] p-6 outline-none resize-y custom-scrollbar leading-relaxed font-medium placeholder-slate-600 focus:text-white transition-colors"
                                placeholder="Your viral caption goes here..."
                            ></textarea>
                        </div>
                    </div>
                    
                </div>
            )}
        </div>
    );
};

export default SocialAutopilot;